module.exports = __webpack_public_path__ + "img/sed-logo.42949dc9.svg";